import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import withRouter from "../../HOC/withRouter";
import { userActions } from "../../store/user/actions";
import { promisify } from "../../utils/promisify";
import { compose } from "react-recompose";
import { makeOppositeShade } from "../../utils/colorService";
import Modal from "react-modal";
import FeedsList from "./FeedsList";

import "./styles.scss";
import AllFeedsIcon from "../../components/svgs/AllFeedsIcon";
import NewFeedsIcon from "../../components/svgs/NewFeedsIcon";
import StickyModal from "../../containers/Journey/StickyModal";

Modal.setAppElement("#root");
class Notifications extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      notificationsOpened: this.props?.history?.location?.state?.notificationsOpened ?? false,
      unseenNotificationsCount: 0,
    };
  }

  componentDidMount = () => {
    promisify(this.props.getUnseenNotificationsCount, {}).then(res => this.setState({ unseenNotificationsCount: res }));
  };

  toggleFeeds = e => {
    promisify(this.props.getNotifications, {})
      .then(promisify(this.props.setSeenStatusBulk, { isSeen: true }))
      .finally(() => {
        this.setState({ notificationsOpened: !this.state.notificationsOpened });
        this.props.navigate({
          state: { notificationsOpened: !this.state.notificationsOpened, unseenNotificationsCount: 0 },
          replace: true,
        });
      });
  };

  render() {
    const { unseenNotificationsCount } = this.state;
    const { client } = this.props;

    return (
      <>
        <div
          className="notifications-container"
          onClick={e => {
            this.toggleFeeds();
            this.setState({
              anchor: e.currentTarget,
            });
          }}
        >
          <span className="notifications-icon">
            {unseenNotificationsCount && !this.state.notificationsOpened ? (
              <NewFeedsIcon color={client?.secondaryColor} color2={makeOppositeShade(client?.bgColor)} />
            ) : (
              <AllFeedsIcon color={client?.secondaryColor} color2={makeOppositeShade(client?.bgColor)} />
            )}
          </span>
          {!!unseenNotificationsCount && !this.state.notificationsOpened && (
            <span className="not-reviewed-count">{unseenNotificationsCount}</span>
          )}
        </div>
        <StickyModal
          separateTitle
          belowAnchor
          rightSideStick
          title={this.props.t("notifications.HeaderLabel")}
          anchor={this.state.anchor}
          onClose={() => {
            this.setState({ anchor: null, unseenNotificationsCount: 0 });
          }}
          modalStyles={{
            maxWidth: "700px",
            width: "100%",
          }}
        >
          <FeedsList
            onClick={() => {
              this.setState({
                anchor: null,
              });
              // this.toggleFeeds()
            }}
          />
        </StickyModal>
      </>
    );
  }
}

const mapStateToProps = state => ({
  unseenNotificationsCount: state.user.unseenNotificationsCount,
  client: state.client.client,
});

export default compose(withRouter, connect(mapStateToProps, userActions))(withTranslation()(Notifications));
